module.exports = __webpack_public_path__ + "static/media/thermistor-conn.4794af73.jpg";